import {CSSProperties, ReactNode, useEffect, useMemo} from "react"
import * as React from 'react'
import { v4 as uuidv4 } from 'uuid'
// import ReactDOM from 'react-dom/client'
// import '../../../../../../static/external/dash/dash.css'
// import '../../../../../../static/external/bootstrap-5.1.3-dist/css/bootstrap.min.css'
// import '../../../../../../static/external/bootstrap-icons-1.6.1/bootstrap-icons.min.css'
// import '../../../../../../static/css/custom.css'
// import '../../../../../../static/css/2.0/html_overrides.css'
// import '../../../../../../static/css/2.0/fonts.css'
// import '../../../../../../static/css/2.0/utilities_align.css'
// import '../../../../../../static/css/2.0/utilities_colors.css'
// import '../../../../../../static/css/2.0/utilities.css'
// import '../../../../../../static/css/2.0/dash_overrides.css'
// import '../../../../../../static/css/2.0/components.css'
import './ElementsTable.css'
import {
    Column,
    createColumnHelper,
    flexRender,
    getCoreRowModel, getFilteredRowModel, getSortedRowModel, Row, SortingFn,
    useReactTable,
} from '@tanstack/react-table'

export interface moduleData {
    id: number
    name: string
}

export interface elementData {
    c_name: string
    s_name: string
    id: number
    name: string
    m_id: number[]
    mapping_type?: "replaced" | "replacing"
    updated?: string[]
    related?: number[]
    status?: "new" | "legacy" | "current"
    locked_by?: string
}

export interface actionData {
    action: "add" | "remove"
    id: number
    m_id: number
}

const modulesData: moduleData[] = [
    {
        "id": 1,
        "name": "ePro"
    },
    {
        "id": 2,
        "name": "AP/I2P"
    },
    {
        "id": 3,
        "name": "P2P"
    },
    {
        "id": 4,
        "name": "Sourcing"
    },
    {
        "id": 5,
        "name": "Spend Analytics"
    },
    {
        "id": 6,
        "name": "SXM"
    },
    {
        "id": 7,
        "name": "CLM"
    },
    {
        "id": 9,
        "name": "S2P"
    },
    {
        "id": 11,
        "name": "SOW"
    },
    {
        "id": 14,
        "name": "Sourcing Opt"
    },
    {
        "id": 15,
        "name": "Direct Sourcing"
    },
    {
        "id": 16,
        "name": "SXM risk enhanced"
    },
    {
        "id": 19,
        "name": "S2C"
    },
    {
        "id": 21,
        "name": "VMS"
    },
    {
        "id": 22,
        "name": "CO2"
    },
    {
        "id": 23,
        "name": "Expense Management"
    },
    {
        "id": 24,
        "name": "TPRM/SCRM"
    }
]

const elementsData: elementData[] = Array.from({length: 100}, (v, k) => k + 1).map(i => ({
    "id": 4000 + i,
    "name": `Model Selection ${i}`,
    "c_name": "Data Storage",
    "s_name": "Data Storage Options",
    "mapping_type": 'replacing',
    "updated": [],
    "related": [4001, 4002],
    "status": 'legacy',
    "m_id": [
        1,
        4,
        6
    ]
}))


const columnHelper = createColumnHelper()


export interface ElementsTableProps {
    /**
     * The ID used to identify this component in Dash callbacks.
     */
    id?: string
    /**
     * A list of dicts specifying the modules to show in the table, each dict has the following keys:
     * - id (number): id of the module
     * - name (string): name of the module
     */
    modules?: moduleData[],
    /**
     * A list of dicts specifying the elements to show in the table, each dict has the following keys:
     * - s_id (number): subcategory id of the element
     * - id (number): id of the element
     * - name (string): name of the element
     * - m_id (number[]): list of module ids where the element is included
     * - change ('replaced'|'new') [optional]: if present, it means that the element is new or has been replaced by another one
     * - related (number[]) [optional]: if present, a list of elements that this is replacing or is being replaced by
     * - locked_by (string) [optional]: if present, the name of the user currently locking that element
     */
    elements?: elementData[],
    /**
     * When a checkbox is clicked, a dict with the following keys: action ("add" or "remove"), id and m_id
     */
    action?: actionData,
    /**
     * URL of the SSE, for real time updates
     */
    eventSourceUrl: string,
    /**
     * Height of the table
     */
    height?: string
    /**
     * Dict specifying the style of the container of the table
     */
    style?: object
    /**
     * ID that uniquely identifies this instance, so we can distinguish between external SSEs and our SSEs
     */
    instanceId?: string
    /**
     * CSS Classes to apply to the container of the table
     */
    className?: string
    /**
     * The children of this component.
     */
    children?: ReactNode
    /**
     * Dash-assigned callback that should be called to report property changes
     * to Dash, to make them available for callbacks.
     */
    setProps: (props: Partial<ElementsTableProps>) => void
}

export const GlobalFilter = ({filter, setFilter}) => {
    return (
        <div style={{position: 'absolute', zIndex: 2, top: 0, width: '24rem', paddingTop: '0.5rem'}}>
            <div className="search-bar ps-3 a-middle-between">
                <i className="bi bi-search purple"></i>
                <input className="dash-input search-bar-input tall" type="text"
                       placeholder="Search by Category, ID, Name..."
                       onChange={(e) => setFilter(e.target.value)}/>
            </div>
        </div>
    )
}

const moduleSortingFn: SortingFn<elementData> = (rowA: Row<elementData>, rowB: Row<elementData>, columnId: string) => {
    const m_id = parseInt(columnId)
    return rowA.original.m_id.includes(m_id) - rowB.original.m_id.includes(m_id)//-1, 0, or 1 - access any row data using rowA.original and rowB.original
}

const getCommonPinningStyles = (column: Column<elementData>, index?: number): CSSProperties => {
    const isPinned = column.getIsPinned()
    const isLastLeftPinnedColumn = isPinned && column.getIsLastColumn('left')
    const isFirstLeftPinnedColumn = isPinned && column.getIsFirstColumn('left')
    const isHeader = index === undefined
    return {
        boxShadow: isLastLeftPinnedColumn ? 'rgba(0, 0, 0, 0.8) 5px 0px 5px -5px inset' : undefined,
        outline: isLastLeftPinnedColumn ? 'none' : undefined,
        padding: isLastLeftPinnedColumn ? 0 : undefined,
        left: isPinned ? `${column.getStart('left')}px` : undefined,
        position: isPinned ? 'sticky' : 'static',
        backgroundColor: isPinned ?
            isLastLeftPinnedColumn ? undefined :
                isHeader ? 'var(--gray)' : 'white'
            : undefined,
        width: column.getSize(),
        minWidth: column.getCanResize() ? undefined : column.getSize(),
        maxWidth: column.getCanResize() ? undefined : column.getSize(),
        zIndex: isPinned ? 10 - column.getPinnedIndex() : 0,
    }
}

const SortableHeader = ({children, column, ...props}) =>
    <div {...props} onClick={column.getToggleSortingHandler()}>{children} {{
        asc: '⮝',
        desc: '⮟'
    }[column.getIsSorted() as string] ?? null}</div>


const init_checkboxes = (elements, modules) =>
    Object.fromEntries(elements?.map(e => [
        e.id,
        Object.fromEntries(modules?.map(m => [
            m.id,
            0
        ]))
    ]))

const ElementsTable = ({modules, elements, eventSourceUrl, ...props}: ElementsTableProps) => {
    const {setProps, children, instanceId, style, className, height} = props

    const data = React.useRef([...elements])
    const [updateTable, setUpdateTable] = React.useState(false)
    const checkboxes = React.useRef(init_checkboxes(elements, modules))

    const onCheckboxMountGetState = (e_id, m_id, setValue) => {
        checkboxes.current[e_id][m_id] = setValue
    }

    const uuid = uuidv4()
    console.log('ElementsTable start...')
    useEffect(() => {
        setProps({instanceId: uuid})
        console.log('Listening to:', eventSourceUrl)
        const eventSource = new EventSource(eventSourceUrl);

        eventSource.onmessage = (event) => {
            if (event.lastEventId === uuid) {
                console.log('This event is ours')
            } else {
                console.log('This event is not ours')
                console.log(event)
                console.log(event.data)
                console.log(event.data.message)
                const eventData = JSON.parse(event.data)
                const externalAction = eventData.message
                const i = data.current.findIndex(e => e.id === externalAction?.id)
                console.log('externalAction: ', externalAction)
                console.log('data.current[', i, ']: ', data.current[i])
                console.log(data.current)
                if (i !== -1) { // If we are filtering the table, we might not have a row that someone is editing
                    if (externalAction?.action === 'add') {
                        data.current[i].m_id = [...data.current[i].m_id, externalAction?.m_id]
                        console.log(checkboxes.current[externalAction?.id])
                        checkboxes.current[externalAction?.id][externalAction?.m_id]([true, externalAction?.user])
                    } else {
                        data.current[i].m_id = [...data.current[i].m_id.filter(m => m != externalAction?.m_id)]
                        checkboxes.current[externalAction?.id][externalAction?.m_id]([false, externalAction?.user])
                    }
                }
            }
        };

        eventSource.onerror = (error) => {
          console.error('EventSource failed:', error);
          eventSource.close();
        };

        return () => {
          // Clean up the event source when the component is unmounted
          eventSource.close();
        };
    }, [eventSourceUrl])

    useEffect(() => {
        console.log('Updating data')
        data.current = [...elements]
        setUpdateTable((prevState) => !prevState)
        console.log(data.current)
    }, [elements])

    useEffect(() => {
        checkboxes.current = init_checkboxes(elements, modules)
    }, [elements, modules])



    const columns = [
        columnHelper.accessor('c_name', {
            id: 'category',
            header: ({column}) => <SortableHeader column={column}>Category</SortableHeader>,
            cell: info => info.getValue(),
            size: 240
        }),
        columnHelper.accessor('s_name', {
            id: 'subcategory',
            header: ({column}) => <SortableHeader column={column}>Subcategory</SortableHeader>,
            cell: info => info.getValue(),
            size: 240
        }),
        columnHelper.accessor('id', {
            id: 'id',
            cell: info => <div id={info.getValue()}>{info.getValue()}</div>,
            header: ({column}) => <SortableHeader column={column}>ID</SortableHeader>,
            size: 60,
            sortingFn: 'alphanumeric'
        }),
        columnHelper.accessor('name', {
            header: ({column}) => <SortableHeader column={column}>Name</SortableHeader>,
            cell: info => info.renderValue(),
            size: 240,
            minSize: 240
        }),
        columnHelper.accessor('mapping_type', {
            header: ({column}) => <SortableHeader column={column}>Info</SortableHeader>,
            cell: ({row}) => <ChangeCell mapping={row.original.mapping_type} updated={row.original.updated}
                                         related={row.original.related} status={row.original.status} row_id={row.original.id}></ChangeCell>,
            size: 95,
            minSize: 95
        }),
        columnHelper.accessor('d', {
            id: 'separator',
            header: () => '',
            cell: info => <span></span>,
            size: 5,
            minSize: 5
        }),
        ...modules?.map(m => columnHelper.accessor('m_id', {
            id: m.id.toString(),
            header: ({column}) => <span data-tooltip={m.name.length > 12 ? m.name : undefined}>
                            <div className='module-header'>
                                <SortableHeader
                                    column={column}>{m.name.length > 12 ? m.name.slice(0, 10) + ".." : m.name}</SortableHeader>
                            </div>
                          </span>,
            sortingFn: moduleSortingFn,
            sortDescFirst: true,
            cell: ({row}) => (
                <CheckboxCell value={m.id} id={row.original.id}
                              checked={row.original.m_id.includes(m.id)}
                              setProps={setProps}
                              data={data}
                              onMount={onCheckboxMountGetState}

                />
            ),
            size: 50
        }))

    ]

    const [globalFilter, setGlobalFilter] = React.useState("");
    const table = useReactTable({
        data: data.current,
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        state: {globalFilter},
        onGlobalFilterChange: setGlobalFilter,
        globalFilterFn: "includesString",
        enableSorting: true,
        sortDescFirst: false,
        initialState: {
            columnPinning: {
                left: ['category', 'subcategory', 'id', 'name', 'mapping_type', 'separator']
            },
            sorting: [{
                id: 'id',
                desc: false
            }]
        },
        enableColumnResizing: false
    })
    return useMemo(() => {
        console.log('Rendering table')
        return (
            <div className={className} style={style}>
                <script
                    src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.10.2/dist/umd/popper.min.js"
                    integrity="sha384-7+zCNj/IqJ95wo16oMtfsKbZ9ccEh31eOz1HGyDuCQ6wgnyJNSYdrPa03rtR1zdB"
                    crossOrigin="anonymous"
                ></script>
                <div style={{border: 'solid 1px var(--gray)', height: height, overflow: 'auto'}}>
                    <table className='elements-table'>
                        <thead className="table-header" style={{position: 'sticky', top: 0, zIndex: 1}}>
                        {table.getHeaderGroups().map(headerGroup => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => (
                                    <th key={header.id} style={{...getCommonPinningStyles(header.column)}}>
                                        {header.id === 'category' &&
                                            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter}/>}
                                        {header.isPlaceholder
                                            ? null
                                            : flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                            )}
                                    </th>
                                ))}
                            </tr>
                        ))}
                        </thead>
                        <tbody style={{zIndex: 0, position: 'relative'}}>
                        {table.getRowModel().rows.map(row => (
                            <tr key={row.id}>
                                {row.getVisibleCells().map(cell => (
                                    <td key={cell.id} style={{...getCommonPinningStyles(cell.column, cell.row.index)}}>
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className="h-4"/>
            </div>
        )
    }, [updateTable, globalFilter, table.getRowModel().rows])
}

export const CheckboxCell = ({checked, value, id, setProps, data, onMount}) => {
    const [updatedCheck, setUpdatedCheck] = React.useState([checked, ''])
    const handleChange = () => {
        setProps({action: {action: !updatedCheck[0] ? 'add' : 'remove', id: id, m_id: value}})
        setUpdatedCheck([!updatedCheck[0], ''])
        const i = data.current.findIndex(e => e.id === id)
        data.current[i].m_id = updatedCheck[0] ? data.current[i].m_id.filter(e => e != value) : [...data.current[i].m_id, value]
    }

    useEffect(() => {
        onMount(id, value, setUpdatedCheck);
    }, []);

    return (
        <div className="position-relative">
            <input className="form-check-input ms-1" type="checkbox" value={value} id={id}
                   checked={updatedCheck[0]}
                   onChange={handleChange}/>
            {(updatedCheck[1] && <div className="user-initials">{updatedCheck[1]}</div>)}
        </div>
    )
}

const UpdateIconMap = {
    's_id': 'diagram-2',
    'element_name': 'tag',
    'element_description': 'text-paragraph',
    'element_definition': 'question-circle',
    'scoring_scale': 'list-ol'
}
const StatusIconMap = {
    'legacy': 'hourglass-bottom orange',
    'new': 'plus-circle purple'
}

function selectContents(el: any) {
    if (el) {
        el.scrollIntoView({behavior: "smooth", block: 'end'})
        let range = document.createRange();
        range.selectNodeContents(el);
        let sel = window.getSelection()!;
        sel.removeAllRanges();
        sel.addRange(range);
    }
}

export const ChangeCell = ({mapping, updated, related, status, row_id}) => {
    let map_labels = related?.map(e_id => <button onClick={() => selectContents(document.getElementById(e_id))}
                                                 className={`d-flex border-0 bg-${mapping === "replaced" ? 'orange' : 'purple'} white fs-6 px-1 rounded`}
                                                 key={row_id + '_' + e_id}>{e_id}</button>)
    let label_icons = updated?.map(change => <i className={`bi bi-${UpdateIconMap[change]} fs-4`} key={row_id + '_' + UpdateIconMap[change]}/>)

    let status_icon = undefined
    if (status !== undefined && status !== 'current') {
        status_icon = <i className={`bi bi-${StatusIconMap[status]} fs-5`} style={{paddingTop: '1px'}}
                         key={row_id + '_status'}/>
    }
    return <div className="a-middle gap-1 flex-wrap" key={row_id}>{status_icon} {map_labels} {label_icons} </div>
}

export default ElementsTable

// const rootElement = document.getElementById('app')
// if (!rootElement) throw new Error('Failed to find the root element')
//
// ReactDOM.createRoot(rootElement).render(
//     <React.StrictMode>
//         <ElementsTable modules={modulesData} elements={elementsData}/>
//     </React.StrictMode>
// )